/**
 * @generated SignedSource<<deafc37d9cb713a8ddd01d2f3a997e10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoEditMainPushNotification_todoWorkspace$data = {
  readonly id: string;
  readonly sendNotificationAtPublish: boolean;
  readonly updatedAtDate: {
    readonly isoString: string;
    readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
  } | null;
  readonly updatedBy: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly " $fragmentType": "WorkspaceTodoEditMainPushNotification_todoWorkspace";
};
export type WorkspaceTodoEditMainPushNotification_todoWorkspace$key = {
  readonly " $data"?: WorkspaceTodoEditMainPushNotification_todoWorkspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainPushNotification_todoWorkspace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoEditMainPushNotification_todoWorkspace",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendNotificationAtPublish",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnzonedDate",
      "kind": "LinkedField",
      "name": "updatedAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FormattedDate"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoString",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "updatedBy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "TodoWorkspace",
  "abstractKey": null
};
})();

(node as any).hash = "20b56481ad0748f3ca89ed859e3860e9";

export default node;
